var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"creation-wizard-step-wrp display-flex flex-wrap width-100 flex-column"},[_c('div',{staticClass:"creation-wizard-step-header"},[_vm._t("header")],2),_c('v-divider',{staticClass:"divider"}),_c('div',{staticClass:"creation-wizard-step-content flex-1"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }